import styled from "styled-components";
import { px2rem } from "../../../../../utils/css";
export const CountDownBox = styled.div `
	display: flex;
	width: inherit;
	height: ${px2rem(21)};
	justify-content: center;
	align-items: center;
	background: rgba(0, 0, 0, 0.4);
	gap: ${px2rem(6)};
`;
export const Time = styled.div `
	height: ${px2rem(16)};
	line-height: ${px2rem(16)};
	font-size: 12px;
	font-family: Avenir-Medium, Avenir;
	font-weight: 500;
	color: #ffffff;
`;
